import {useI18nContext} from '@teladoc/pulse/ui/Context/i18n';
import useTransLoader from 'i18n/use-trans-loader';
import css from './Footer.scss';

const FooterPublic = () => {
    const {t} = useTransLoader('footer');
    const {selectedLang} = useI18nContext();
    const localePath =
        selectedLang !== 'en-US' ? `/${selectedLang.toLowerCase()}` : '';
    const PRIVACY_POLICY_URL = `https://www.teladochealth.com${localePath}/legal/privacy-policy`;
    const TERMS_OF_SERVICE_URL = `https://www.teladochealth.com${localePath}/legal/terms-of-service`;
    const PRIVACY_PRACTICES_URL = `https://www.teladochealth.com${localePath}/legal/notice-of-privacy-practices`;

    return (
        <footer className={css.root}>
            <div className={css.container}>
                <p className={css.company}>&copy; Teladoc Health, Inc</p>
                <p className={css.links}>
                    <a
                        target="_blank"
                        className={css.link}
                        rel="noopener noreferrer"
                        href={TERMS_OF_SERVICE_URL}
                    >
                        {t('terms')}
                    </a>
                    <a
                        target="_blank"
                        className={css.link}
                        rel="noopener noreferrer"
                        href={PRIVACY_POLICY_URL}
                    >
                        {t('privacy')}{' '}
                    </a>
                    <a
                        target="_blank"
                        className={css.link}
                        rel="noopener noreferrer"
                        href={PRIVACY_PRACTICES_URL}
                    >
                        {t('privacyPractices')}{' '}
                    </a>
                </p>
                <span>
                    {t('version')}{' '}
                    {window?.process?.env?.VERSION ?? process.env.VERSION}
                </span>
            </div>
        </footer>
    );
};

export default FooterPublic;
